import React, {Component} from 'react';
import {Provider} from 'react-redux';
import store from './store';
import Router from './router';


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        console.log('Version:', process.env.REACT_APP_VERSION);
    }

    render() {
        return (
            <Provider store={store}>
                <Router/>
            </Provider>
        );
    }
}

export default App;
